import { takeLatest, call, put } from 'redux-saga/effects';
import { OrganizationManagementApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes } from './constants';
import {
    getMaintenanceScheduleAction,
    addMaintenanceScheduleAction,
    getMicroServiceScheduleData
} from './actions';
import { notify } from 'sharedComponents/GeneralNotification';
import { NOTIFICATION_TYPES } from 'sharedComponents/GeneralNotification/constants';
import { translate } from 'helpers/translateHelper';


function* fetchMaintenanceSchedule({ organizationID }) {
    yield put(getMaintenanceScheduleAction(apiCallStatus.LOADING));
    try {
        const response = yield call(OrganizationManagementApi.getMaintenanceScheduleMicroService, organizationID);
        const geMicroServicetScheduleData = response?.maintenanceSchedules ?? [];
        yield put(getMaintenanceScheduleAction(apiCallStatus.SUCCESS, geMicroServicetScheduleData?.[0] ?? {}));
        yield put(getMicroServiceScheduleData(geMicroServicetScheduleData));
        logger.debug('Maintanence schedule successfully loaded for page ');
    } catch (err) {
        yield put(getMaintenanceScheduleAction(apiCallStatus.ERROR, [], err));
    }
}

function* addMaintenanceSchedule({
    organizationId,
    scheduleId,
    microServiceScheduleData,
    isForSave
}) {
    yield put(addMaintenanceScheduleAction(apiCallStatus.LOADING));
    try {
        const response = yield call(OrganizationManagementApi.addMaintenanceScheduleMicroService, organizationId, scheduleId, microServiceScheduleData);
        yield put(addMaintenanceScheduleAction(apiCallStatus.SUCCESS, response?.maintenanceCycles?.[0] || microServiceScheduleData));
        notify(
            translate(
                isForSave
                    ? 'ABB.Powertrain.Frontend.addMaintenanceScheduleSuccess'
                    : 'ABB.Powertrain.Frontend.resetMaintenanceScheduleSuccess'
            ),
            NOTIFICATION_TYPES.SUCCESS
        );
    } catch (err) {
        yield put(addMaintenanceScheduleAction(apiCallStatus.ERROR, [], err));
    }
}

export function* SensorFirmwareManagementWatchers() {
    yield takeLatest(actionTypes.GET_MAINTENANCE_SCHEDULE_REQUEST, fetchMaintenanceSchedule);
    yield takeLatest(actionTypes.ADD_MAINTENANCE_SCHEDULE_REQUEST, addMaintenanceSchedule);
}
